import React from 'react';

import { VulnerabilityIntelligenceIcon } from 'pages/Landings/components/Icons';
import Paragraph from 'pages/Landings/components/Paragraph';
import TopicContent from 'pages/Landings/components/TopicContent';
import TopicHeading from 'pages/Landings/components/TopicHeading';
import TopicTemplate from 'pages/Landings/components/TopicTemplate';

const VulnerabilityIntelligence: React.FC = () => {
    return (
        <TopicTemplate
            heading={
                <TopicHeading
                    title="Vulnerability Intelligence"
                    description="Query the Vulners database to get enriched context for CVE, including all metrics, exploitability, and correlated real‑world risk signals. Bring this context closer to your decision‑making."
                    illustration={<VulnerabilityIntelligenceIcon />}
                />
            }
            content={
                <TopicContent link="https://docs.vulners.com/docs/products/intelligence/">
                    <Paragraph
                        primary="One API, Complete Context"
                        secondary="Stop stitching feeds and guessing from partial signals. With Vulners Intelligence, a single API call delivers the full, normalized picture for any CVE - CVSS (with vectors), EPSS, KEV status, CWE, patches, exploit references, and Vulners AI Risk indicators - cleanly structured and machine-readable so you can drop it straight into your UI, SIEM, or ticketing."
                    />
                    <Paragraph
                        primary="Prioritize Like an Attacker"
                        secondary="Prioritize like an attacker, not a spreadsheet. Elevate issues with live exploitation or KEV inclusion over quiet “10.0s,” so your backlog reflects real-world threat pressure instead of raw scores. Analysts get an immediate 360° view for each CVE in one consistent response, which drives better decisions and faster action."
                    />
                    <Paragraph
                        primary="Built to Ship, Not Babysit"
                        secondary="This service is built for product teams. Our high-reliability API (99.9% SLA) becomes your enrichment backend, so you don’t maintain parsers or chase feeds. Clean JSON and consistent fields—backed by a graph-linked corpus - let you add tooltips, drill-downs, and “why this matters” callouts without assembling data from disparate sources."
                    />
                    <Paragraph
                        primary="Plug In Once, Enrich Everywhere"
                        secondary="Plug in once; ship intelligence everywhere, and drop research time to near-zero by enriching scan results and asset inventories in-line."
                    />
                </TopicContent>
            }
        />
    );
};

export default VulnerabilityIntelligence;
